import React from "react";
import CongratsAnimation from "./CongratsAnimation";
import FormLayout from "./FormLayout";
import { useDispatch, useSelector } from "react-redux";
import { returnsSlice } from "../store/reducer/returns";
import { DownloadReturnTask } from "../utils/tasks";
import { returnsApi } from "../api/ReturnsApi";
import { RootState } from "../store";
import { PaymentOption } from "../model/final_balance/payment_option.d";

// TODO: kinda awkward but seems I can't access user email to display where confirmation was sent
const FinalConfirmation = () => {
  const dispatch = useDispatch();
  const stateState = useSelector((state: RootState) => state.state);
  const { paymentChoice } = useSelector((state: RootState) => state.payment);
  const downloadReturnPDF = async (e: any) => {
    e.preventDefault();
    dispatch(returnsSlice.actions.addTask(DownloadReturnTask));
    try {
    const pdf = await returnsApi.downloadTaxReturn(stateState.taxReturnID!);
    // create file link in browser's memory
    const href = URL.createObjectURL(pdf);

    // create "a" HTML element with href to file & click
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', `${stateState.taxYear}-return-summary.pdf`);
    document.body.appendChild(link);
    link.click();

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
    } finally {
      dispatch(returnsSlice.actions.removeTask(DownloadReturnTask.id));
    }
  }

  const receiptCopy = (paymentChoice: PaymentOption) => {
    if (paymentChoice === PaymentOption.PayNow) {
      return 'A receipt and confirmation email have';
    } else {
      return 'A confirmation email has';
    }
  }

  return (
    <>
      <CongratsAnimation />
      <FormLayout
        title={"Thank you!"}
        description={"Congratulations on completing your tax return. " + receiptCopy(paymentChoice) + " been sent to the email address on file."}
      >
        <p><a href="#" onClick={downloadReturnPDF}><b><u>Download a PDF summary</u></b></a> of your return.</p>
      </FormLayout>
    </>
  );
};

export default FinalConfirmation;
